import React from 'react';
import styles from './Footer.module.css';

function Footer() {
  return <div></div>;
}

export default Footer;
